import moment from "moment";

export const strip = (html) => {
    var tmp = document.createElement("div");
    tmp.innerHTML = html || '';
    return tmp.textContent || tmp.innerText;
}


export const blobToBase64 = blob => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const getInitials = (name) => {
  if (!name) return '';
  const [lastName, firstName, patronymic] = name.split(' ').filter(_ => _)
  return `${firstName?.[0] || ''}. ${patronymic?.[0] || ''}. ${lastName}`
}

export const getDndCriterions = (list) => {
  return list?.map((item, ind) => {
    const {criterions, name, child_criterion_json, id, ...rest} = item
    return {
      id: id,
      initId: id,
      value: name, 
      collapsed: true,
      children: getDndCriterions(criterions || child_criterion_json),
      ...rest
    }
  }) || []
}

export const getModifyCriterions = (list, upperChapter) => {
  

  return list?.map((item, ind) => {
    const chapter = upperChapter ||ind + 1
    const topLevelItem = {
      name: item.value,
      points: item.points || null,
      documents: item.documents || null,
      description: item.description || null,
      chapter,
      child_criterion_json: item.children?.length ? getModifyCriterions(item.children, chapter) : []
    }

    item.initId && (topLevelItem.id = item.initId)

    // const {valid_from, valid_till, documents, description, ...otherLevelItem} = topLevelItem 
    
    // return level ? {...otherLevelItem} : {...topLevelItem}
    return topLevelItem
  }) || []
}

export const getModifyParts = (parts) => {
  return parts?.map(part => {
    if (part.files_json && Array.isArray(part.files_json)) {
      return {
        ...part,
        files_json: [...part.files_json].sort((a, b) => {
          const numA = parseInt(a.filename?.match(/^(\d+)/)?.[1]) || 0;
          const numB = parseInt(b.filename?.match(/^(\d+)/)?.[1]) || 0;
          return numA - numB;
        })
      };
    }
    return part;
  }) || [];
}

export const getCurrentPeriod = (periods) => {
  const now = new Date();
  const sortedPeriods = [...periods].sort((a, b) => new Date(a.date_from) - new Date(b.date_from));
  
  const currentPeriod = sortedPeriods.find(({ date_from, date_to }) => {
    const from = new Date(date_from);
    const to = new Date(date_to);
    return from <= now && now <= to;
  });
  
  if (currentPeriod) {
    return currentPeriod;
  }
  
  const nextPeriod = sortedPeriods.find(({ date_from }) => {
    const from = new Date(date_from);
    return from > now;
  });

  return nextPeriod || sortedPeriods[0];
}

// Возвращает ближайший предстоящий период (помеченный на бэке is_next)
// или undefined, если будущих периодов нет.
export const getNextPeriod = (periods) => periods?.find(({ is_next }) => is_next);

// Период считается уже наступившим (или прошедшим), если его дата начала
// меньше текущего момента. Согласовано с отключением прошедших вариантов
// в getCertificationPeriodsOptionsForTeacher.
export const isPeriodStarted = (dateFrom) => !!dateFrom && new Date(dateFrom) < new Date();

export const getDaysToCommission = (commissionList) => {
  if (!commissionList) return undefined;
  const nextCommission = commissionList.find(i => i.is_next)
  if (!nextCommission) return undefined;
  return moment(nextCommission.date_from).diff(moment(), 'days') + 1;
}

export const getCurrentCommission = (certPeriods, periodId) => {
  if (!certPeriods) return {};
  if (!periodId) return certPeriods.find(({is_current}) => is_current)
  return certPeriods.find(({id}) => id == periodId)
}

export const sanitizeQuillValue = (html) => {
  return html
    .replace(/[\uD800-\uDFFF]/g, '')    // strip surrogate pairs / emoji (4-byte UTF-8)
    .replace(/\u202F/g, ' ')            // narrow no-break space (Word inserts before digits) → regular space
    .replace(/\u00A0/g, ' ')            // non-breaking space → regular space
    .replace(/\u00AD/g, '')             // soft hyphen
    .replace(/\u200B/g, '')             // zero-width space
    .replace(/\uFEFF/g, '')             // BOM / zero-width no-break space
}